import {Controller} from '@hotwired/stimulus';
import * as Leaflet from 'leaflet';
import markerUrl from '../../images/leaflet-marker.svg';

export default class extends Controller {

    connect() {

        this.leafletMarkers = [];
        const context = this;
        const element = this.element;

        const mapElm = element.querySelector(".map");
        if ( !mapElm.hasAttribute("data-markers") ) return;

        const markers = JSON.parse(mapElm.getAttribute("data-markers"));
        if (markers.length < 1) return;

        const center = [markers[0]['lat'], markers[0]['lng']];
        const zoom = 13;
        const map = Leaflet.map(mapElm, {
            center: center,
            zoom: zoom,
            zoomSnap: false,
            scrollWheelZoom: false,
        })

        Leaflet.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            attribution: '',
            id: 'demovilius/clc5w1dr3004915pjaq1u0niu',
            tileSize: 512,
            zoomOffset: -1,
            accessToken: 'pk.eyJ1IjoiZGVtb3ZpbGl1cyIsImEiOiJjam5zeTJsaWswM2UxM3JvMXppamxkeXl2In0.gSBxj7rBcrJANrH_IzleiA',
        }).addTo(map)

        context.markerIcon = Leaflet.icon({
            iconUrl: markerUrl,
            iconSize: [40, 50],
            iconAnchor: [20, 50],
            popupAnchor: [0, 0],
        });

        markers.forEach(function(marker) {

            const leafletMarker = Leaflet
                .marker([marker['lat'], marker['lng']], { icon: context.markerIcon })
                .addTo(map)

            context.leafletMarkers.push(leafletMarker);
        })
    }

}
